import React, { PureComponent } from "react";
import { FilterCard } from "../Common/Cards/FilterCard";

import _ from "i18n";
import collaboratorApi from "../../services/CollaboratorServices";
import CardsContainerFetching from "./CardsContainerFetching";

class CardsContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isGeneric: true,
      hover: false,
      folderCount: 0,
      generalFolderCount: 0,
      isFiltred: false,
      loading: false,
      statistics: [],
      error: false
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      year,
      synchro,
      spaceAs,
      filterCollaborator,
      filtersClientCRMGroupe,
      filtersClientCRMType,
      filtersjuridicalForms,
      filterRoleCollaborateur,
      searchedValue,
      clientIds
    } = this.props;
    if (
      prevProps.year !== year ||
      prevProps.spaceAs !== spaceAs ||
      prevProps.synchro !== synchro ||
      prevProps.filterCollaborator !== filterCollaborator ||
      prevProps.filtersClientCRMGroupe !== filtersClientCRMGroupe ||
      prevProps.filtersClientCRMType !== filtersClientCRMType ||
      prevProps.filtersjuridicalForms !== filtersjuridicalForms ||
      prevProps.filterRoleCollaborateur !== filterRoleCollaborateur ||
      prevProps.searchedValue !== searchedValue ||
      prevProps.clientIds !== clientIds
    ) {
      this.handleUpdateClientFoldersStats(year, synchro, spaceAs);
    }
    if (
      prevProps.filterCollaborator !== filterCollaborator ||
      prevProps.filtersClientCRMGroupe !== filtersClientCRMGroupe ||
      prevProps.filtersClientCRMType !== filtersClientCRMType ||
      prevProps.filtersjuridicalForms !== filtersjuridicalForms ||
      prevProps.filterRoleCollaborateur !== filterRoleCollaborateur ||
      prevProps.searchedValue !== searchedValue ||
      prevProps.clientIds !== clientIds
    ) {
      this.setState({
        isFiltred: true
      });
    }
    this.props.handleChangeCardsFetching(this.state.loading);
  }

  componentDidMount() {
    const { year, synchro, spaceAs } = this.props;

    if (synchro !== null) {
      this.handleUpdateClientFoldersStats(year, synchro, spaceAs);
    } else {
      this.setState({
        loading: true
      });
    }
  }

  handleUpdateClientFoldersStats = (year, synchro, spaceAs) => {
    const {
      organization,
      user,
      filtersClientCRMType,
      filtersClientCRMGroupe,
      filtersjuridicalForms,
      filterRoleCollaborateur,
      searchedValue,
      clientIds
    } = this.props;

    const searchParams = new URLSearchParams(window.location.search);
    let juridicalForms = [];
    filtersjuridicalForms.map(element => {
      juridicalForms.push(element.label);
    });
    this.setState({
      loading: true
    });
    collaboratorApi
      .getCollaboratorClientFolders(
        organization,
        user.id,
        searchParams.get("collaboratorId") || null,
        filterRoleCollaborateur,
        "LIST_CLIENT",
        year,
        synchro,
        spaceAs,
        filtersClientCRMType,
        filtersClientCRMGroupe,
        juridicalForms,
        searchedValue,
        clientIds
      )
      .then(response => {
        let items = response.data.data;
        let count = 0;
        let total = 0;
        items.forEach(item => {
          count = count + item.total;
          total = total + item.totalFolders;
        });

        this.setState({
          statistics: items,
          folderCount: count,
          generalFolderCount: total,
          loading: false
        });
      })
      .catch(error => {
        this.setState({
          error: true,
          loading: false
        });
      });
  };

  render() {
    let {
      folderCount,
      statistics,
      loading,
      generalFolderCount,
      isFiltred
    } = this.state;
    return (
      <div>
        {loading ? (
          <CardsContainerFetching />
        ) : (
          <div
            className="grid-x align-center"
            style={{
              width: "92%",
              maxWidth: "92%",
              margin: "auto"
            }}
          >
            <FilterCard
              isActive={"" == this.props.configState}
              onClick={() => {
                this.props.handleOrganizationListFilterConfigState("");
              }}
              isGeneric={true}
              title={_("clientFolders")}
              totalNumber={folderCount}
              generalTotalNumber={generalFolderCount}
              isFiltred={isFiltred}
              color={"#fff"}
            />
            {statistics.map((item, i) => {
              return (
                <FilterCard
                  isActive={item.code == this.props.configState}
                  onClick={() => {
                    this.props.handleOrganizationListFilterConfigState(
                      item.code
                    );
                  }}
                  isGeneric={false}
                  title={_(item.label)}
                  totalNumber={item.total}
                  generalFolderNumber={item.totalFolders}
                  isFiltred={isFiltred}
                  percentage={(item.total / folderCount) * 100}
                  color={
                    item.code === "CONFIGURED"
                      ? "#06D9B1"
                      : item.code === "NO_ANNEXES"
                        ? "#FFB340"
                        : "#F9626D"
                  }
                />
              );
            })}
          </div>
        )}
      </div>
    );
  }
}

export default CardsContainer;



// WEBPACK FOOTER //
// ./src/components/OrganizationList/CardsContainer.js